import { createElement, removeFromParent } from 'app/utils/DOM';
export class TextMeasurer {
    constructor(opts) {
        Object.defineProperty(this, "span", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "style", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const { el } = opts;
        if (!el || !el.ownerDocument) {
            throw new Error('Missing required parameter');
        }
        this.createStyle(el);
        this.createSpan(el);
    }
    measureText(text, format, _size) {
        if (!text) {
            return {
                width: 0,
                height: 0,
                lines: [],
            };
        }
        const style = {
            fontFamily: `'${format.fontFamily}'`,
            fontSize: `${format.fontSize}${format.metrics}`,
            lineHeight: format.lineHeight,
        };
        Object.keys(style).forEach((key) => {
            this.span.style[key] = style[key];
        });
        this.span.innerHTML = '';
        const doc = this.span.ownerDocument;
        const textLines = text.split(/\r\n|\n|\r/gm);
        // just remove last empty line
        if (textLines.length > 0) {
            const lastLine = textLines[textLines.length - 1];
            if (!lastLine.length || lastLine.match(/\r\n|\n|\r/gm)) {
                textLines.pop();
            }
        }
        textLines.forEach(lineText => {
            const para = doc.createElement('p');
            const htmlText = lineText.match(/^\s*$/g)
                ? /* &nbsp; */ '&#xA0'
                : lineText;
            para.innerHTML = `<s>${htmlText}</s>`;
            this.span.appendChild(para);
        });
        const bounds = this.span.getBoundingClientRect();
        const descender = document.createElement('span');
        const lineMetrics = [...this.span.querySelectorAll('p')].map((elem, index) => {
            const metrics = this.textMetricsFromHtmlDom(elem.querySelector('s'), descender);
            return Object.assign(Object.assign({}, metrics), { text: textLines[index] });
        });
        this.span.innerHTML = '';
        return {
            width: bounds.width,
            height: bounds.height,
            lines: lineMetrics,
        };
    }
    attach() {
        /* noop */
    }
    detach() {
        removeFromParent(this.span);
        removeFromParent(this.style);
    }
    textMetricsFromHtmlDom(dom, workSpan) {
        const bounds = dom.getBoundingClientRect();
        const { width } = bounds;
        const { height } = bounds;
        workSpan = workSpan || document.createElement('span');
        workSpan.setAttribute('style', 'width: 0px!important; height: 1px!important; display: inline-block!important;');
        dom.appendChild(workSpan);
        const ascent = workSpan.offsetTop - dom.offsetTop;
        const descent = height - ascent;
        dom.removeChild(workSpan);
        // const textEl = dom.querySelector('s');
        const x = dom.offsetLeft;
        const y = dom.offsetTop + ascent; // aka. baseline
        return {
            x,
            y,
            width,
            height,
            ascent,
            descent,
        };
    }
    createSpan(container) {
        const doc = container.ownerDocument;
        if (!this.style) {
            throw new Error('Missing measurer styles');
        }
        const cls = this.style.attributes.getNamedItem('id').value;
        const measurer = createElement(doc, 'span');
        measurer.className = `${cls}`;
        container.appendChild(measurer);
        this.span = measurer;
    }
    createStyle(container) {
        const doc = container.ownerDocument;
        const style = createElement(doc, 'style');
        const name = `measurer-${Date.now()}`;
        style.setAttribute('type', 'text/css');
        style.setAttribute('id', name);
        style.innerHTML = `
            .${name} {
                position: absolute;
                top: 0;
                left: 0;
                font-family: sans-serif;
                user-select: text;
                line-height: 0;
                cursor: text;
                transform-origin: 0 0;
            }
            .${name}__is-hidden {
                opacity: 0;
            }
            .${name} * {
                max-height: none;
            }
            .${name} p, .${name} s {
                white-space: nowrap!important;
                box-sizing: inherit!important;
                margin: 0!important;
                padding: 0!important;
                text-decoration: none!important;
                border: 0!important;
                font-weight: normal!important;
            }
        `;
        container.appendChild(style);
        this.style = style;
    }
    static mount(...params) {
        return new TextMeasurer(...params);
    }
}
